<script>
    import {
        eventGroupState
    } from '@app/store/eventGroupStore.svelte.js';
    import {
        projectState
    } from '@app/store/projectStore.svelte.js';
    import * as m from '@app/paraglide/messages.js';
    import { filterState } from '@app/store/editorStore.svelte.js';
    import { getFilteredEventIndices } from '@app/lib/eventValidation.js';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    function selectAllBefore() {
        try {
            const eventGroup = eventGroupState[projectState.selected];
            const currentIndex = eventGroup?.selected?.[0];

            if (typeof currentIndex !== 'number') {
                return;
            }

            const events = eventGroup.events;
            const filteredIndices = getFilteredEventIndices(events, eventGroup, filterState);
            eventGroupState[projectState.selected].selected = filteredIndices.filter(index => index <= currentIndex);
        } catch (err) {
            console.log(err);
            console.log(err.message);
        } finally {
            dispatch('done');
        }
    }
</script>

<a
    id="selectAllBeforeBtn"
    class="dropdown-item"
    role="button"
    aria-label={m.context_menu_select_all_before_label()}
    href="#!/"
    onclick={selectAllBefore}>
    {m.context_menu_select_all_before()}
</a>
